import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20ddc3c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./mobile-workbench.less?vue&type=style&index=0&id=20ddc3c8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ddc3c8",
  null
  
)

export default component.exports